class ContratoUsuariosService extends AbstractService

  configure: (configs, injector) ->
    configs.url = '/'

  add: (empresa_id, cpf, callback) ->
    @doRequest('POST', {cpf: cpf}, callback, {
      url: "/api/empresas/#{empresa_id}/permissoes"
    })

  getList: (empresa_id, callback) ->
    @doRequest('GET', {}, callback, {
      url: "/api/empresas/#{empresa_id}/permissoes"
    })

  atualizar: (empresa_id, usuario_id, dados, callback) ->
    @doRequest('PUT', {permissao: dados}, callback, {
      url: "/api/empresas/#{empresa_id}/permissoes/#{usuario_id}"
    })

  delete: (empresa_id, usuario_id, callback) ->
    @doRequest('DELETE', {}, callback, {
      url: "/api/empresas/#{empresa_id}/permissoes/#{usuario_id}"
    })

  addUsuario: (empresa, usuario, callback) ->
    @doRequest('POST', {empresa_id: empresa, usuario: usuario}, callback, {
      url: "/api/usuarios"
    })


angular.module('eficienciaFiscalModule').service('contratoUsuariosService', ContratoUsuariosService)
